import { hash as keccak256 } from "../../../crypto/Keccak256/hash.js";
import { serialize } from "./serialize.js";

/**
 * Factory: Compute transaction hash.
 *
 * @param {Object} deps - Crypto dependencies
 * @param {(data: Uint8Array) => Uint8Array} deps.keccak256 - Keccak256 hash function
 * @returns {(tx: import('./TransactionEIP4844Type.js').TransactionEIP4844Type) => Uint8Array} Function that computes transaction hash
 *
 * @see https://voltaire.tevm.sh/primitives/transaction for Transaction documentation
 * @since 0.0.0
 * @throws {never} Never throws
 * @example
 * ```javascript
 * import { Hash } from './primitives/Transaction/EIP4844/hash.js';
 * import { hash as keccak256 } from '../../../crypto/Keccak256/hash.js';
 * const hash = Hash({ keccak256 });
 * const txHash = hash(tx);
 * ```
 */
export function Hash({ keccak256 }) {
	return function hash(tx) {
		return keccak256(serialize(tx));
	};
}

// Default export with crypto injected
export const hash = Hash({ keccak256 });
